export default __webpack_public_path__ + "static/media/img.b56dcc95.jpg";